export enum CountryISO2 {
  AF = 'Afghanistan',
  AX = 'Åland_Islands',
  AL = 'Albania',
  DZ = 'Algeria',
  AS = 'American_Samoa',
  AD = 'Andorra',
  AO = 'Angola',
  AI = 'Anguilla',
  AQ = 'Antarctica',
  AG = 'Antigua_And_Barbuda',
  AR = 'Argentina',
  AM = 'Armenia',
  AW = 'Aruba',
  AU = 'Australia',
  AT = 'Austria',
  AZ = 'Azerbaijan',
  BS = 'Bahamas',
  BH = 'Bahrain',
  BD = 'Bangladesh',
  BB = 'Barbados',
  BY = 'Belarus',
  BE = 'Belgium',
  BZ = 'Belize',
  BJ = 'Benin',
  BM = 'Bermuda',
  BT = 'Bhutan',
  BO = 'Bolivia',
  BQ = 'Bonaire_Sint_Eustatius_And_Saba',
  BA = 'Bosnia_And_Herzegovina',
  BW = 'Botswana',
  BV = 'Bouvet_Island',
  BR = 'Brazil',
  IO = 'British_Indian_Ocean_Territory',
  BN = 'Brunei_Darussalam',
  BG = 'Bulgaria',
  BF = 'Burkina_Faso',
  BI = 'Burundi',
  CV = 'Cabo_Verde',
  KH = 'Cambodia',
  CM = 'Cameroon',
  CA = 'Canada',
  KY = 'Cayman_Islands',
  CF = 'Central_African_Republic',
  TD = 'Chad',
  CL = 'Chile',
  CN = 'China',
  CX = 'Christmas_Island',
  CC = 'Cocos_Islands',
  CO = 'Colombia',
  KM = 'Comoros',
  CG = 'Congo',
  CD = 'Congo_Democratic_Republic',
  CK = 'Cook_Islands',
  CR = 'Costa_Rica',
  CI = 'Cote_dIvoire',
  HR = 'Croatia',
  CU = 'Cuba',
  CW = 'Curaçao',
  CY = 'Cyprus',
  CZ = 'Czechia',
  DK = 'Denmark',
  DJ = 'Djibouti',
  DM = 'Dominica',
  DO = 'Dominican_Republic',
  EC = 'Ecuador',
  EG = 'Egypt',
  SV = 'El_Salvador',
  GQ = 'Equatorial_Guinea',
  ER = 'Eritrea',
  EE = 'Estonia',
  SZ = 'Eswatini',
  ET = 'Ethiopia',
  FK = 'Falkland_Islands',
  FO = 'Faroe_Islands',
  FJ = 'Fiji',
  FI = 'Finland',
  FR = 'France',
  GF = 'French_Guiana',
  PF = 'French_Polynesia',
  TF = 'French_Southern_Territories',
  GA = 'Gabon',
  GM = 'Gambia',
  GE = 'Georgia',
  DE = 'Germany',
  GH = 'Ghana',
  GI = 'Gibraltar',
  GR = 'Greece',
  GL = 'Greenland',
  GD = 'Grenada',
  GP = 'Guadeloupe',
  GU = 'Guam',
  GT = 'Guatemala',
  GG = 'Guernsey',
  GN = 'Guinea',
  GW = 'Guinea_Bissau',
  GY = 'Guyana',
  HT = 'Haiti',
  HM = 'Heard_Island_And_McDonald_Islands',
  VA = 'Holy_See',
  HN = 'Honduras',
  HK = 'Hong_Kong',
  HU = 'Hungary',
  IS = 'Iceland',
  IN = 'India',
  ID = 'Indonesia',
  IR = 'Iran',
  IQ = 'Iraq',
  IE = 'Ireland',
  IM = 'Isle_of_Man',
  IL = 'Israel',
  IT = 'Italy',
  JM = 'Jamaica',
  JP = 'Japan',
  JE = 'Jersey',
  JO = 'Jordan',
  KZ = 'Kazakhstan',
  KE = 'Kenya',
  KI = 'Kiribati',
  KP = 'Korea_Democratic_Peoples_Republic',
  KR = 'Korea_Republic',
  KW = 'Kuwait',
  KG = 'Kyrgyzstan',
  LA = 'Lao_Peoples_Democratic_Republic',
  LV = 'Latvia',
  LB = 'Lebanon',
  LS = 'Lesotho',
  LR = 'Liberia',
  LY = 'Libya',
  LI = 'Liechtenstein',
  LT = 'Lithuania',
  LU = 'Luxembourg',
  MO = 'Macao',
  MG = 'Madagascar',
  MW = 'Malawi',
  MY = 'Malaysia',
  MV = 'Maldives',
  ML = 'Mali',
  MT = 'Malta',
  MH = 'Marshall_Islands',
  MQ = 'Martinique',
  MR = 'Mauritania',
  MU = 'Mauritius',
  YT = 'Mayotte',
  MX = 'Mexico',
  FM = 'Micronesia',
  MD = 'Moldova',
  MC = 'Monaco',
  MN = 'Mongolia',
  ME = 'Montenegro',
  MS = 'Montserrat',
  MA = 'Morocco',
  MZ = 'Mozambique',
  MM = 'Myanmar',
  NA = 'Namibia',
  NR = 'Nauru',
  NP = 'Nepal',
  NL = 'Netherlands',
  NC = 'New_Caledonia',
  NZ = 'New_Zealand',
  NI = 'Nicaragua',
  NE = 'Niger',
  NG = 'Nigeria',
  NU = 'Niue',
  NF = 'Norfolk_Island',
  MK = 'North_Macedonia',
  MP = 'Northern_Mariana_Islands',
  NO = 'Norway',
  OM = 'Oman',
  PK = 'Pakistan',
  PW = 'Palau',
  PS = 'Palestine',
  PA = 'Panama',
  PG = 'Papua_New_Guinea',
  PY = 'Paraguay',
  PE = 'Peru',
  PH = 'Philippines',
  PN = 'Pitcairn',
  PL = 'Poland',
  PT = 'Portugal',
  PR = 'Puerto_Rico',
  QA = 'Qatar',
  RE = 'Réunion',
  RO = 'Romania',
  RU = 'Russian_Federation',
  RW = 'Rwanda',
  BL = 'Saint_Barthélemy',
  SH = 'Saint_Helena',
  KN = 'Saint_Kitts_And_Nevis',
  LC = 'Saint_Lucia',
  MF = 'Saint_Martin_French_Part',
  PM = 'Saint_Pierre_And_Miquelon',
  VC = 'Saint_Vincent_And_The_Grenadines',
  WS = 'Samoa',
  SM = 'San_Marino',
  ST = 'Sao_Tome_And_Principe',
  SA = 'Saudi_Arabia',
  SN = 'Senegal',
  RS = 'Serbia',
  SC = 'Seychelles',
  SL = 'Sierra_Leone',
  SG = 'Singapore',
  SX = 'Sint_Maarten_Dutch_Part',
  SK = 'Slovakia',
  SI = 'Slovenia',
  SB = 'Solomon_Islands',
  SO = 'Somalia',
  ZA = 'South_Africa',
  GS = 'South_Georgia_And_The_South_Sandwich_Islands',
  SS = 'South_Sudan',
  ES = 'Spain',
  LK = 'Sri_Lanka',
  SD = 'Sudan',
  SR = 'Suriname',
  SJ = 'Svalbard_and_Jan_Mayen',
  SE = 'Sweden',
  CH = 'Switzerland',
  SY = 'Syrian_Arab_Republic',
  TW = 'Taiwan_Province_Of_China',
  TJ = 'Tajikistan',
  TZ = 'Tanzania',
  TH = 'Thailand',
  TL = 'Timor_Leste',
  TG = 'Togo',
  TK = 'Tokelau',
  TO = 'Tonga',
  TT = 'Trinidad_And_Tobago',
  TN = 'Tunisia',
  TR = 'Turkey',
  TM = 'Turkmenistan',
  TC = 'Turks_And_Caicos_Islands',
  TV = 'Tuvalu',
  UG = 'Uganda',
  UA = 'Ukraine',
  AE = 'United_Arab_Emirates',
  GB = 'United_Kingdom_Of_Great_Britain_And_Northern_Ireland',
  UM = 'United_States_Minor_Outlying_Islands',
  US = 'United_States_Of_America',
  UY = 'Uruguay',
  UZ = 'Uzbekistan',
  VU = 'Vanuatu',
  VE = 'Venezuela',
  VN = 'Viet_Nam',
  VG = 'Virgin_Islands_British',
  VI = 'Virgin_Islands_US',
  WF = 'Wallis_And_Futuna',
  EH = 'Western_Sahara',
  YE = 'Yemen',
  ZM = 'Zambia',
  ZW = 'Zimbabwe'
}
